import React, { useState, useEffect } from 'react';
import { Camera, Save, Upload, Lock, X, User, ShieldCheck, Landmark, MapPin } from 'lucide-react';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import '../../../css/custom-scrollbar.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import { Base_Url, userdata, updateprofile, Url_For_View_Document } from '../../../config/config';
import { useNavigate } from 'react-router-dom';

const B2bUserProfileEdit = () => {
    const [hasExistingAccount, setHasExistingAccount] = useState(false);
    const [originalAccountNo, setOriginalAccountNo] = useState('');
    const [hasExistingAccountHolder, setHasExistingAccountHolder] = useState(false);
    const [originalAccountHolder, setOriginalAccountHolder] = useState('');
    const [hasExistingBankName, setHasExistingBankName] = useState(false);
    const [originalBankName, setOriginalBankName] = useState('');
    const [hasExistingIfscCode, setHasExistingIfscCode] = useState(false);
    const [originalIfscCode, setOriginalIfscCode] = useState('');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [cancelCheckFile, setCancelCheckFile] = useState(null);
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const [isLoading, isSetLoading] = useState(false);
    const navigate = useNavigate();

    const [profileImagePreview, setProfileImagePreview] = useState(null);
    const [selectedProfileImage, setSelectedProfileImage] = useState(null);

    const [userData, setUserData] = useState({
        id: cusid,
        company_name: "test",
        name: '',
        bio: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        account_holder: '',
        bank_name: '',
        account_no: '',
        ifsc_code: ''
    });

    const handleCancelCheckUpload = (event) => {
        const file = event.target.files[0];
        setCancelCheckFile(file);
    };

    const handleProfileImage = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setSelectedProfileImage(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleCancelCheckRemove = () => {
        setCancelCheckFile(null);
    };

    const generateInitialsAvatar = (name) => {
        if (!name) return null;
        const initials = name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();
        return (
            <div
                className={`rounded-full flex items-center justify-center text-3xl font-semibold w-full h-full ${isDarkMode ? 'bg-gradient-to-br from-indigo-600 to-purple-600 text-white' : 'bg-black text-white'}`}
            >
                {initials}
            </div>
        );
    };

    useEffect(() => {
        fetchUserData();
    }, [cusid, token]);

    const fetchUserData = async () => {
        const url = Base_Url + userdata;
        if (cusid) {
            try {
                const response = await fetch(url + "/" + cusid, {
                    method: 'GET',
                    headers: {
                        'token': token,
                        'cus_id': cusid,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();
                if (result.status === "SUCCESS") {
                    const { data } = result;
                    if (data.account_no) {
                        setHasExistingAccount(true);
                        setOriginalAccountNo(data.account_no);
                    }
                    if (data.account_holder_name) {
                        setHasExistingAccountHolder(true);
                        setOriginalAccountHolder(data.account_holder_name);
                    }
                    if (data.bank_name) {
                        setHasExistingBankName(true);
                        setOriginalBankName(data.bank_name);
                    }
                    if (data.ifsc_code) {
                        setHasExistingIfscCode(true);
                        setOriginalIfscCode(data.ifsc_code);
                    }

                    setUserData({
                        id: cusid,
                        name: data.name || '',
                        company_name: data.company_name || '',
                        bio: data.bio,
                        email: data.email || '',
                        phone: data.phone || '',
                        website: data.website || '',
                        address: data.address || '',
                        account_holder: data.account_holder_name,
                        bank_name: data.bank_name,
                        account_no: data.account_no || '',
                        ifsc_code: data.ifsc_code
                    });
                    if (data.profile_image) {
                        const profileWithUrl = Url_For_View_Document + data.profile_image
                        setProfileImagePreview(profileWithUrl);
                    }
                    else {
                        setProfileImagePreview(data.profile_image);
                    }
                } else {
                    toast.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Something went wrong. Please try again.');
            }
        }
    };

    const handleSubmit = async () => {
        const formData = new FormData();
        if (hasExistingAccount) {
            formData.append('account_no', originalAccountNo);
        } else {
            formData.append('account_no', userData.account_no);
        }

        if (hasExistingAccountHolder) {
            formData.append('account_holder', originalAccountHolder);
        } else {
            formData.append('account_holder', userData.account_holder);
        }

        if (hasExistingBankName) {
            formData.append('bank_name', originalBankName);
        } else {
            formData.append('bank_name', userData.bank_name);
        }

        if (hasExistingIfscCode) {
            formData.append('ifsc_code', originalIfscCode);
        } else {
            formData.append('ifsc_code', userData.ifsc_code);
        }

        for (const key in userData) {
            if (!['account_no', 'account_holder', 'bank_name', 'ifsc_code'].includes(key)) {
                formData.append(key, userData[key]);
            }
        }

        if (selectedProfileImage) {
            formData.append('profile_image', selectedProfileImage);
        }

        if (cancelCheckFile) {
            formData.append('cancel_check', cancelCheckFile);
        }

        try {
            isSetLoading(true);
            const response = await axios.post(`${Base_Url}${updateprofile}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cusid,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                isSetLoading(false);
                setTimeout(() => {
                    navigate("/b2b/dashboard");
                }, 1000)
            } else {
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.profile_image);
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.account_no);
                toast.error(response.data.message.address);
                toast.error(response.data.message.website);
                toast.error(response.data.message.cancel_check);
                isSetLoading(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Something went wrong. Please try again.');
            isSetLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === 'phone') {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(value)) {
                return;
            }
        }
        if (
            (id === 'account_no' && hasExistingAccount) ||
            (id === 'account_holder' && hasExistingAccountHolder) ||
            (id === 'bank_name' && hasExistingBankName) ||
            (id === 'ifsc_code' && hasExistingIfscCode)
        ) {
            return;
        }
        setUserData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    // shared field classes for compact monochrome inputs
    const fieldBase = "w-full px-2.5 py-1.5 text-[10px] border rounded-lg transition-all duration-150 outline-none";

    // 🎨 Editable — light me same, dark me indigo glowing
    const fieldEditable = isDarkMode
        ? 'bg-[#1a1a2e] text-white border-2 border-indigo-400/50 placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]'
        : 'bg-white text-black border-black/20 focus:border-black focus:ring-1 focus:ring-black';

    // 🎨 Locked — light me same, dark me dim
    const fieldLocked = isDarkMode
        ? 'border-2 border-indigo-400/25 bg-[#0f0f1c] text-indigo-200/60 cursor-not-allowed'
        : 'border-black/10 bg-black/5 text-black/50 cursor-not-allowed';

    const labelBase = `flex items-center gap-1 text-[9px] font-medium mb-0.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`;

    const cardBase = isDarkMode
        ? 'border border-indigo-500/20 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] rounded-lg p-3 shadow-[0_4px_20px_rgba(79,70,229,0.12)]'
        : 'border border-black/10 bg-white rounded-lg p-3';

    const badgeBase = isDarkMode
        ? 'px-2 py-0.5 border border-indigo-500/40 bg-indigo-500/10 text-[8px] rounded-full text-indigo-200'
        : 'px-2 py-0.5 border border-black/20 text-[8px] rounded-full text-black/50';

    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
            <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

            <NavBar />

            <div className="flex flex-1 overflow-hidden">

                   <div
                        className={`${isToggleSidebar ? "md:w-64" : "md:w-20"} w-0 m-0 md:m-3 md:rounded-3xl ${glass} overflow-visible md:overflow-hidden transition-all duration-300 ease-in-out flex-shrink-0`}>
                        <Sidebar />
                    </div>
                <div className={`${isDarkMode ? 'bg-black' : 'bg-gray-100'} w-full flex-1 overflow-hidden flex flex-col`}>

                    {/* Page Header */}
                    <div className={`flex-shrink-0 px-3 sm:px-4 py-2.5 border-b flex items-center justify-between gap-2 ${isDarkMode ? 'border-indigo-500/20 bg-black' : 'border-black/10 bg-gray-200'}`}>
                        <div className="min-w-0">
                            <h1 className={`text-sm font-semibold flex items-center gap-2 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                <span className={`w-1 h-4 rounded-full flex-shrink-0 ${isDarkMode ? 'bg-gradient-to-b from-indigo-500 to-purple-600' : 'bg-red-600'}`}></span>
                                Edit Profile
                            </h1>
                            <p className={`text-[9px] mt-0.5 ml-3 ${isDarkMode ? 'text-indigo-300/60' : 'text-black/40'}`}>Manage your personal, contact &amp; payout details</p>
                        </div>
                        <button
                            className={`flex items-center gap-1.5 px-3 py-2 sm:py-1.5 rounded-lg text-[10px] font-medium transition-all duration-150 hover:opacity-85 disabled:opacity-60 flex-shrink-0 ${isDarkMode
                                ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-900/50 hover:from-indigo-500 hover:to-purple-500'
                                : 'bg-red-600 text-white'
                                }`}
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? <Spinner /> : <><Save className="w-3.5 h-3.5" /><span>Save</span></>}
                        </button>
                    </div>

                    {/* Body */}
                    <div className="flex-1 min-h-0 flex flex-col lg:flex-row gap-2.5 px-3 py-2.5 overflow-y-auto lg:overflow-hidden custom-scrollbar">

                        {/* LEFT: Profile summary */}
                        <div className="w-full lg:w-64 flex-shrink-0 flex flex-col gap-2.5">
                            <div className={`${cardBase} flex flex-col items-center text-center`}>
                                <div className="relative">
                                    <div className={`w-20 h-20 sm:w-24 sm:h-24 rounded-full overflow-hidden border-2 ${isDarkMode ? 'border-indigo-400/50 shadow-[0_0_20px_rgba(99,102,241,0.3)]' : 'border-black/20'}`}>
                                        {profileImagePreview ? (
                                            <img
                                                src={profileImagePreview}
                                                alt="Profile"
                                                className="w-full h-full object-cover"
                                            />
                                        ) : (
                                            generateInitialsAvatar(userData.name)
                                        )}
                                    </div>
                                    <button
                                        onClick={() => document.getElementById("profileImageInput").click()}
                                        className={`absolute bottom-0 right-0 p-1.5 rounded-full shadow transition-transform duration-150 hover:scale-105 ${isDarkMode
                                            ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-900/50'
                                            : 'bg-black text-white'
                                            }`}
                                    >
                                        <Camera className="w-3 h-3" />
                                    </button>
                                    <input
                                        type="file"
                                        id="profileImageInput"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        style={{ display: 'none' }}
                                        onChange={handleProfileImage}
                                    />
                                </div>
                                <p className={`mt-2 text-xs font-semibold truncate max-w-full ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                    {userData.name || 'Your Name'}
                                </p>
                                <p className={`text-[9px] truncate max-w-full ${isDarkMode ? 'text-indigo-300/60' : 'text-black/40'}`}>
                                    {userData.email}
                                </p>
                                <div className={`w-full border-t mt-2.5 pt-2 ${isDarkMode ? 'border-indigo-500/20' : 'border-black/10'}`}>
                                    <span className={`flex items-center justify-center gap-1.5 text-[8px] ${isDarkMode ? 'text-indigo-300/50' : 'text-black/30'}`}>
                                        <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black/50'}`}></div>
                                        Auto-saved on submit
                                    </span>
                                </div>
                            </div>

                            <div className={cardBase}>
                                <label htmlFor="bio" className={`block text-[9px] font-semibold uppercase tracking-wide mb-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                                    Biography
                                </label>
                                <textarea
                                    id="bio"
                                    placeholder="Tell us about yourself..."
                                    value={userData.bio}
                                    onChange={handleInputChange}
                                    className={`${fieldBase} ${fieldEditable} resize-none`}
                                    rows="4"
                                ></textarea>
                            </div>
                        </div>

                        {/* RIGHT: Scrollable details */}
                        <div className="flex-1 min-h-0 lg:overflow-y-auto custom-scrollbar space-y-2.5 lg:pr-1">

                            {/* Public Information */}
                            <div className={cardBase}>
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className={`flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-200' : 'text-black/80'}`}>
                                        <User className="w-3 h-3" /> Public Information
                                    </h2>
                                    <span className={badgeBase}>Visible to others</span>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                                    <div>
                                        <label htmlFor="name" className={labelBase}>
                                            Full Name *
                                        </label>
                                        <input
                                            id="name"
                                            type="text"
                                            placeholder="Enter your full name"
                                            value={userData.name}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldEditable}`}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="username" className={labelBase}>
                                            Username
                                        </label>
                                        <input
                                            id="username"
                                            type="text"
                                            placeholder="Choose a username"
                                            value={userData.company_name}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldEditable}`}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Private Information */}
                            <div className={cardBase}>
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className={`flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-200' : 'text-black/80'}`}>
                                        <ShieldCheck className="w-3 h-3" /> Private Information
                                    </h2>
                                    <span className={badgeBase}>Personal details</span>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2.5">
                                    <div>
                                        <label htmlFor="email" className={labelBase}>
                                            Email <Lock className="w-2 h-2 opacity-50" />
                                        </label>
                                        <input
                                            id="email"
                                            type="email"
                                            placeholder="Email address"
                                            disabled
                                            value={userData.email}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldLocked}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="phone" className={labelBase}>
                                            Phone <Lock className="w-2 h-2 opacity-50" />
                                        </label>
                                        <input
                                            id="phone"
                                            type="tel"
                                            placeholder="Enter phone number"
                                            disabled
                                            value={userData.phone}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldLocked}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="website" className={labelBase}>
                                            Website
                                        </label>
                                        <input
                                            id="website"
                                            type="url"
                                            placeholder="https://your-website.com"
                                            value={userData.website}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldEditable}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="UserId" className={labelBase}>
                                            User ID <Lock className="w-2 h-2 opacity-50" />
                                        </label>
                                        <input
                                            id="UserId"
                                            type="text"
                                            placeholder="User ID"
                                            disabled
                                            value={userData.id}
                                            onChange={handleInputChange}
                                            className={`${fieldBase} ${fieldLocked}`}
                                        />
                                    </div>
                                </div>

                                <div className="mt-2.5">
                                    <label htmlFor="address" className={labelBase}>
                                        <MapPin className="w-2.5 h-2.5" /> Address
                                    </label>
                                    <textarea
                                        id="address"
                                        placeholder="Enter your complete address"
                                        value={userData.address}
                                        onChange={handleInputChange}
                                        className={`${fieldBase} ${fieldEditable} resize-none`}
                                        rows="2"
                                    ></textarea>
                                </div>
                            </div>

                            {/* Bank Details */}
                            <div className={cardBase}>
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className={`flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-200' : 'text-black/80'}`}>
                                        <Landmark className="w-3 h-3" /> Bank Details
                                    </h2>
                                    <span className={badgeBase}>Financial info</span>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2.5">
                                    <div>
                                        <label htmlFor="account_holder" className={labelBase}>
                                            A/C Holder
                                            {hasExistingAccountHolder && <Lock className="w-2 h-2 opacity-50" />}
                                        </label>
                                        <input
                                            id="account_holder"
                                            type="text"
                                            placeholder="Enter Account Holder Name"
                                            value={hasExistingAccountHolder ? originalAccountHolder : userData.account_holder}
                                            onChange={handleInputChange}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                                            }}
                                            disabled={hasExistingAccountHolder}
                                            className={`${fieldBase} ${hasExistingAccountHolder ? fieldLocked : fieldEditable}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="bank_name" className={labelBase}>
                                            Bank Name
                                            {hasExistingBankName && <Lock className="w-2 h-2 opacity-50" />}
                                        </label>
                                        <input
                                            id="bank_name"
                                            type="text"
                                            placeholder="Enter Bank Name"
                                            value={hasExistingBankName ? originalBankName : userData.bank_name}
                                            onChange={handleInputChange}
                                            disabled={hasExistingBankName}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                                            }}
                                            className={`${fieldBase} ${hasExistingBankName ? fieldLocked : fieldEditable}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="account_no" className={labelBase}>
                                            A/C Number
                                            {hasExistingAccount && <Lock className="w-2 h-2 opacity-50" />}
                                        </label>
                                        <input
                                            id="account_no"
                                            type="text"
                                            placeholder="Enter Account Number"
                                            value={hasExistingAccount ? originalAccountNo : userData.account_no}
                                            onChange={handleInputChange}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                            }}
                                            disabled={hasExistingAccount}
                                            className={`${fieldBase} ${hasExistingAccount ? fieldLocked : fieldEditable}`}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="ifsc_code" className={labelBase}>
                                            IFSC Code
                                            {hasExistingIfscCode && <Lock className="w-2 h-2 opacity-50" />}
                                        </label>
                                        <input
                                            id="ifsc_code"
                                            type="text"
                                            placeholder="Enter IFSC Code"
                                            value={hasExistingIfscCode ? originalIfscCode : userData.ifsc_code}
                                            onChange={handleInputChange}
                                            disabled={hasExistingIfscCode}
                                            className={`${fieldBase} ${hasExistingIfscCode ? fieldLocked : fieldEditable}`}
                                        />
                                    </div>
                                </div>

                                {/* Cancel Check Upload */}
                                <div className={`mt-2.5 p-2.5 rounded-lg border border-dashed ${isDarkMode
                                    ? 'border-indigo-500/30 bg-indigo-500/5'
                                    : 'border-black/10 bg-black/5'
                                    } flex flex-col sm:flex-row sm:items-center gap-2`}>
                                    <label className={`text-[9px] font-medium flex-shrink-0 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/60'}`}>
                                        Cancelled Check
                                        <span className={`block text-[8px] ${isDarkMode ? 'text-indigo-300/50' : 'text-black/30'}`}>PDF, JPG, JPEG, PNG</span>
                                    </label>
                                    <input
                                        type="file"
                                        id="cancel-check-upload"
                                        className="hidden"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={handleCancelCheckUpload}
                                    />
                                    <label
                                        htmlFor="cancel-check-upload"
                                        className={`flex items-center gap-1.5 px-2.5 py-2 sm:py-1 rounded-md cursor-pointer text-[9px] font-medium transition-all duration-150 hover:opacity-85 w-full sm:w-fit justify-center sm:justify-start ${isDarkMode
                                            ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-900/50'
                                            : 'bg-black text-white'
                                            }`}
                                    >
                                        <Upload className="w-3 h-3" />
                                        <span>Choose File</span>
                                    </label>

                                    {cancelCheckFile && (
                                        <div className={`flex items-center gap-1 px-2 py-0.5 rounded-md border ${isDarkMode
                                            ? 'border-indigo-500/30 bg-indigo-500/10'
                                            : 'border-black/10 bg-black/5'
                                            }`}>
                                            <span className={`text-[9px] font-medium max-w-[100px] sm:max-w-[140px] truncate ${isDarkMode ? 'text-indigo-200' : 'text-black/70'}`}>
                                                {cancelCheckFile.name}
                                            </span>
                                            <button
                                                onClick={handleCancelCheckRemove}
                                                className={`transition-colors duration-150 ${isDarkMode ? 'text-indigo-300/60 hover:text-white' : 'text-black/40 hover:text-black'}`}
                                                type="button"
                                            >
                                                <X className="w-3 h-3" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default B2bUserProfileEdit;  